import { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Innovation", to: "/innovation" },
  { label: "Products", to: "/products" },
  { label: "Sustainability", to: "/sustainability" },
  { label: "Vision", to: "/vision" },
  { label: "Journal", to: "/journal" },
  { label: "Intelligence", to: "/water-intelligence" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 bg-[#F5F5F7] transition-shadow duration-300 ${
        scrolled ? "border-b border-[#D2D2D7]/60" : "border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-14">
        <Link to="/" data-testid="navbar-logo" className="flex items-center">
          <img src="/nyla-logo.png" alt="Nyla Air Water" className="h-12 w-auto" />
        </Link>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-xs font-medium transition-colors duration-200 ${
                  isActive ? "text-[#1D1D1F] font-semibold" : "text-[#1D1D1F]/80 hover:text-[#1D1D1F]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            data-testid="nav-cta-partner"
            className="px-5 py-2 rounded-full bg-[#1D1D1F] text-white text-xs font-medium hover:bg-black active:scale-95 transition-[background-color,transform] duration-200"
          >
            Partner With Us
          </Link>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-[#1D1D1F]"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-[#F5F5F7] border-t border-[#D2D2D7]/60 px-6 py-8 flex flex-col gap-6"
        >
          {[...links, { label: "Contact", to: "/contact" }].map((l) => (
            <Link
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className="text-base font-medium text-[#1D1D1F] hover:text-[#2C3E35] transition-colors"
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/contact"
            data-testid="mobile-cta-partner"
            onClick={() => setOpen(false)}
            className="mt-2 px-5 py-3 rounded-full bg-[#1D1D1F] text-white text-sm font-medium text-center active:scale-95 transition-transform duration-200"
          >
            Partner With Us
          </Link>
        </div>
      )}
    </header>
  );
};
